import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTheme } from '@/store/useTheme'
import { useSession } from '@/store/useSession'
import {
  readClients,
  SESSION_TYPE_LABELS,
  type ClientRecord,
} from '@/store/clients'
import styles from './ClientsPage.module.css'

export default function ClientsPage() {
  const { palette } = useTheme()
  const navigate    = useNavigate()
  const location    = useLocation()
  const { setClientName, setPractitioner, setShared } = useSession()

  const [clients, setClients] = useState<ClientRecord[]>(() => readClients())

  useEffect(() => {
    if (location.pathname === '/clients') {
      setClients(readClients())
    }
  }, [location.pathname])

  const paletteVars = {
    '--cl-bg':   palette.bg,
    '--cl-text': palette.text,
    '--cl-ring': palette.ring,
  } as React.CSSProperties

  function handleBeginSession(client: ClientRecord) {
    setClientName(client.name)
    setPractitioner({
      relationshipType: client.sessionType,
    })
    setShared({ dataConsent: client.dataConsent })
    navigate('/setup')
  }

  return (
    <main className={styles.page} style={paletteVars} aria-label="Client list">
      <div className={styles.inner}>

        <header className={styles.header}>
          <h1 className={styles.title}>Your clients</h1>
          <button
            type="button"
            className={styles.addBtn}
            onClick={() => navigate('/clients/add')}
          >
            + Add client
          </button>
        </header>

        {clients.length === 0 ? (
          <div className={styles.empty}>
            <p className={styles.emptyText}>
              This is where your clients will appear.
            </p>
          </div>
        ) : (
          <ul className={styles.list}>
            {clients.map(client => (
              <li key={client.id} className={styles.card}>
                <div className={styles.cardText}>
                  <p className={styles.cardHeading}>{client.name}</p>
                  <p className={styles.cardSubtitle}>
                    {SESSION_TYPE_LABELS[client.sessionType]}
                  </p>
                </div>
                <div className={styles.cardActions}>
                  <button
                    type="button"
                    className={styles.aboutBtn}
                    onClick={() => navigate(`/clients/${client.id}`)}
                  >
                    About {client.name}
                  </button>
                  <button
                    type="button"
                    className={styles.beginBtn}
                    onClick={() => handleBeginSession(client)}
                    aria-label={`Begin session with ${client.name}`}
                  >
                    Begin session
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}

      </div>
    </main>
  )
}
